export const INIT_UNSENT_STATE = {
  backgroundColor: "",
  textColor: "",
  text: "",
  to: ""
};
export const GET_AMOUNT_POST_API = "/amountPost";
export const POST_MESSAGE_API = "/post";
